import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setPatientAllergiesOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { filterHiddenOptions, sortAlphabeticallyByName } from '../../../utilities/options.util'
import { IHideableOptionsResponse } from '../store/options.types'

export function* getPatientAllergiesOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const patientAllergyOptionsResponse: IHideableOptionsResponse = yield call([
      optionsService,
      optionsService.getPatientAllergiesOptions,
    ])
    const { entity } = patientAllergyOptionsResponse
    sortAlphabeticallyByName(entity)

    yield put(setPatientAllergiesOptions(filterHiddenOptions(entity)))
  } catch (e) {
    yield put(throwPcrException(`getPatientAllergiesOptions() error: ${e}`))
  }
}

export function* getPatientAllergiesOptionsSaga() {
  yield takeLatest(
    [PCRConstants.CREATE_PCR, ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS],
    getPatientAllergiesOptions
  )
}
